var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"banner-merchant-container"},_vm._l((_setup.bannerLayoutList),function(item,index){return (_setup.bannerLayoutList?.length)?_c(_setup.MultiJumpContainer,{key:index,staticClass:"banner-merchant",attrs:{"imgUrl":item.imgUrl,"biTag":item.biTag,"jumpInfo":{
        jumpUrl: item.jumpUrl,
        appid: item.appid,
        username: item.username,
        path:item.path,
      }}}):_vm._e()}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }